module.exports = __webpack_public_path__ + "static/media/correo.4f105587.svg";